import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import PlayPauseButton from './PlayPauseButton';
import VolumeButton from './VolumeButton';
import VolumeSlider from './VolumeSlider';

const Container = styled.div`
    display: flex;
    margin-left: -10px;
    align-items: center;
`;

const Controls = (props) => {

    const {
        paused,
        volume,
        muted,
        lastVolume,
        mediaPlayer,
        setWasPlaying,
        deviceInfo,
    } = props;

    if(!mediaPlayer) {

        return null;

    }

    const isDesktop = deviceInfo?.formFactor === 'desktop';

    return (
        <Container>
            <PlayPauseButton
                paused={paused}
                mediaPlayer={mediaPlayer}
                setWasPlaying={setWasPlaying}
            />
            {
                isDesktop
                && (
                    <>
                        <VolumeButton
                            volume={volume}
                            muted={muted}
                            lastVolume={lastVolume}
                            mediaPlayer={mediaPlayer}
                        />
                        <VolumeSlider
                            volume={volume}
                            muted={muted}
                            mediaPlayer={mediaPlayer}
                        />
                    </>
                )
            }
        </Container>
    );

};

Controls.propTypes = {
    paused: PropTypes.bool.isRequired,
    volume: PropTypes.number.isRequired,
    muted: PropTypes.bool.isRequired,
    lastVolume: PropTypes.number.isRequired,
    setWasPlaying: PropTypes.func.isRequired,
    mediaPlayer: PropTypes.object,
    deviceInfo: PropTypes.object,
};

Controls.defaultProps = {
    mediaPlayer: {},
    deviceInfo: {},
};

export default Controls;
